import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Header from './components/Header8';
import Footer from './components/Footer8';

const FAQs8 = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        { q: 'How do I place an order?', a: 'Browse our collection, select your preferred size and quantity, add items to your bag, and proceed to checkout. You can pay via credit/debit card, UPI, or cash on delivery.' },
        { q: 'What is your return policy?', a: 'We offer a 7-day hassle-free return policy. If you are not satisfied with your purchase, you can initiate a return within 7 days of delivery. Items must be unworn, unwashed, and in original packaging.' },
        { q: 'Do you offer customization?', a: 'Yes! Many of our pieces can be customized for size, length, and embroidery preferences. Contact us at hello@mehak.com for bespoke requests. Custom orders take 2-3 weeks.' },
        { q: 'What are the shipping charges?', a: 'We offer free shipping on all orders above \u20B91,999. For orders below \u20B91,999, a flat shipping fee of \u20B999 applies. Standard delivery takes 5-7 business days.' },
        { q: 'How can I track my order?', a: 'Once your order is shipped, you will receive a tracking number via email and SMS. You can also track your order from the Orders page in your account.' },
        { q: 'Do you ship internationally?', a: 'Yes, we ship to select international destinations. International shipping typically takes 10-15 business days. Customs duties may apply based on your country.' },
        { q: 'How do I care for my MEHAK garments?', a: 'We recommend dry cleaning for silk and embroidered pieces. Cotton garments can be hand-washed with mild detergent. Always store ethnic wear in muslin cloth bags to preserve the fabric.' },
        { q: 'Can I cancel my order?', a: 'Orders can be cancelled within 24 hours of placement. Once the order has been dispatched, it cannot be cancelled. Please contact our support team for assistance.' },
    ];

    const categories = ['Ordering', 'Shipping', 'Returns', 'Care'];

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=DM+Sans:wght@300;400;500;700&display=swap');`}</style>
            <div style={{ fontFamily: "'DM Sans', sans-serif" }} className="min-h-screen bg-white">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-3xl mx-auto">
                        <div className="text-center mb-12">
                            <p className="text-sm tracking-[0.3em] uppercase mb-3 font-medium" style={{ color: '#BE185D' }}>Help Center</p>
                            <h1 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-3xl lg:text-5xl font-bold mb-4">Frequently Asked Questions</h1>
                            <p className="text-base" style={{ color: '#6B7280' }}>Everything you need to know about shopping with MEHAK</p>
                        </div>

                        <div className="space-y-3">
                            {faqs.map((faq, i) => (
                                <div key={i} className="rounded-xl overflow-hidden" style={{ border: '1px solid #F9A8D4', backgroundColor: openIndex === i ? '#FDF2F8' : '#FFFFFF' }}>
                                    <button
                                        onClick={() => setOpenIndex(openIndex === i ? null : i)}
                                        className="w-full flex items-center justify-between p-5 text-left"
                                    >
                                        <span className="text-sm font-semibold pr-4" style={{ color: '#1A1A1A' }}>{faq.q}</span>
                                        {openIndex === i ? <ChevronUp size={18} style={{ color: '#BE185D', flexShrink: 0 }} /> : <ChevronDown size={18} style={{ color: '#6B7280', flexShrink: 0 }} />}
                                    </button>
                                    {openIndex === i && (
                                        <div className="px-5 pb-5">
                                            <p className="text-sm leading-relaxed" style={{ color: '#6B7280' }}>{faq.a}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="text-center mt-12 p-8 rounded-xl" style={{ backgroundColor: '#FDF2F8' }}>
                            <h3 style={{ fontFamily: "'Libre Baskerville', serif" }} className="text-xl font-bold mb-2">Still have questions?</h3>
                            <p className="text-sm mb-4" style={{ color: '#6B7280' }}>Our team is here to help you bloom.</p>
                            <button onClick={() => window.location.href = '/template8/contact'} className="px-6 py-3 rounded-lg text-sm font-semibold uppercase tracking-wider" style={{ backgroundColor: '#BE185D', color: '#FFFFFF' }}>
                                Contact Us
                            </button>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default FAQs8;
